import React from 'react';
import cx from 'classnames';

import styles from './SurveyCompletedMessage.scss';

const SurveyCompletedMessage = () => (
  <div className={styles.container}>
    <i className={cx('icon-custom-circle-check', styles.icon)} />
    <div className={styles.message}>Thanks for taking our survey!</div>
  </div>
);

export default SurveyCompletedMessage;
